'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _times = require('HubStyleTokens/times');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PopoverContext = require('../context/PopoverContext');

var PopoverContext = _interopRequireWildcard(_PopoverContext);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _TwoWayTransition = require('../transitions/TwoWayTransition');

var _TwoWayTransition2 = _interopRequireDefault(_TwoWayTransition);

var _PlacementConstants = require('./PlacementConstants');

var _UIPopoverArrow = require('./UIPopoverArrow');

var _UIPopoverArrow2 = _interopRequireDefault(_UIPopoverArrow);

var _UIPopoverBody = require('./UIPopoverBody');

var _UIPopoverBody2 = _interopRequireDefault(_UIPopoverBody);

var _UIPopoverFooter = require('./UIPopoverFooter');

var _UIPopoverFooter2 = _interopRequireDefault(_UIPopoverFooter);

var _UIPopoverHeader = require('./UIPopoverHeader');

var _UIPopoverHeader2 = _interopRequireDefault(_UIPopoverHeader);

var _Use = require('./utils/Use');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isReactNode = function isReactNode(node) {
  return (typeof node === 'undefined' ? 'undefined' : _typeof(node)) !== 'object' || (0, _react.isValidElement)(node) || Array.isArray(node);
};

var transitionDuration = parseInt(_times.POPOVER_TRANSITION_TIMING, 10);

var renderStructuredContent = function renderStructuredContent(content, onOpenChange, showCloseButton) {
  var header = content.header,
      body = content.body,
      footer = content.footer,
      step = content.step;


  return [header && _react2.default.createElement(
    _UIPopoverHeader2.default,
    {
      key: 'header',
      showCloseButton: showCloseButton,
      onOpenChange: onOpenChange
    },
    header
  ), body && _react2.default.createElement(
    _UIPopoverBody2.default,
    { key: 'body' },
    body
  ), (footer || step) && _react2.default.createElement(
    _UIPopoverFooter2.default,
    {
      key: 'footer',
      hasStructuredFooter: !!footer,
      hasStep: !!step
    },
    step,
    footer
  )];
};

var transformOriginMixin = (0, _styledComponents.css)(['', ';', ';'], ['top', 'bottom', 'left', 'right'].map(function (side) {
  return '.tether-element-attached-' + side + ' & { transform-origin: ' + side + ' }';
}), ['top', 'bottom'].map(function (ySide) {
  return ['left', 'right'].map(function (xSide) {
    return '.tether-element-attached-' + ySide + '.tether-element-attached-' + xSide + ' & { transform-origin: ' + ySide + ' ' + xSide + ' }';
  });
}));

var PopoverTransitionWrapper = (0, _styledComponents2.default)(_TwoWayTransition2.default.PlainWrapper).withConfig({
  displayName: 'UIPopoverContent__PopoverTransitionWrapper'
})(['transition-property:', ';transition-duration:', 'ms;opacity:', ';transform:', ';', ';'], function (_ref) {
  var transitioning = _ref.transitioning;
  return transitioning ? 'opacity, transform' : 'none';
}, function (_ref2) {
  var duration = _ref2.duration;
  return duration;
}, function (_ref3) {
  var open = _ref3.open;
  return open ? '1' : '0';
}, function (_ref4) {
  var open = _ref4.open,
      transitioning = _ref4.transitioning;

  if (open && !transitioning) return 'none'; /* IE bugfix: #5368 */
  return open ? 'scale(1)' : 'scale(.75)';
}, transformOriginMixin);

var UIPopoverContent = (0, _react.forwardRef)(function (props, ref) {
  var animateOnMount = props.animateOnMount,
      animateOnToggle = props.animateOnToggle,
      arrowColor = props.arrowColor,
      arrowSize = props.arrowSize,
      className = props.className,
      content = props.content,
      Content = props.Content,
      onCloseComplete = props.onCloseComplete,
      _onCloseStart = props.onCloseStart,
      _onKeyDown = props.onKeyDown,
      _onOpenComplete = props.onOpenComplete,
      onOpenStart = props.onOpenStart,
      open = props.open,
      placement = props.placement,
      style = props.style,
      use = props.use,
      showCloseButton = props.showCloseButton,
      onOpenChange = props.onOpenChange,
      width = props.width,
      rest = _objectWithoutProperties(props, ['animateOnMount', 'animateOnToggle', 'arrowColor', 'arrowSize', 'className', 'content', 'Content', 'onCloseComplete', 'onCloseStart', 'onKeyDown', 'onOpenComplete', 'onOpenStart', 'open', 'placement', 'style', 'use', 'showCloseButton', 'onOpenChange', 'width']);

  var _useState = (0, _react.useState)(props.open && !props.animateOnMount),
      _useState2 = _slicedToArray(_useState, 2),
      openComplete = _useState2[0],
      setOpenComplete = _useState2[1];

  var computedOpen = open && (Content || content);
  var computedArrowParams = _UIPopoverArrow2.default.ARROW_SIZES[arrowSize];

  var renderedContent = Content ? _react2.default.createElement(Content, null) : content;

  if (process.env.NODE_ENV !== 'production') {
    if (showCloseButton && (isReactNode(renderedContent) || !renderedContent.header)) {
      _devLogger2.default.warn({
        message: 'UIPopover: `showCloseButton={true}` requires you to provide the `content` prop as an object with a `header`.',
        key: 'UIPopover: showCloseButton'
      });
    }
  }

  var renderedPopover = computedOpen && _react2.default.createElement(
    PopoverContext.Provider,
    { value: { use: use } },
    _react2.default.createElement(
      'div',
      _extends({}, rest, {
        className: (0, _classnames2.default)(className, _Use.USE_CLASSES[use], 'private-popover uiPopover'),
        'data-open-complete': openComplete,
        onKeyDown: function onKeyDown(evt) {
          if (_onKeyDown) _onKeyDown(evt);
          if (evt.key === 'Escape') onOpenChange((0, _SyntheticEvent2.default)(false));
        },
        style: width ? _extends({
          maxWidth: width,
          width: width
        }, style) : style,
        ref: ref
      }),
      _react2.default.createElement(_UIPopoverArrow2.default, {
        color: arrowColor,
        inset: computedArrowParams.inset,
        key: 'arrow',
        placement: placement,
        width: computedArrowParams.width,
        popoverUse: use
      }),
      _react2.default.createElement(
        'div',
        { className: 'private-popover__inner' },
        isReactNode(renderedContent) ? renderedContent : renderStructuredContent(renderedContent, onOpenChange, showCloseButton)
      )
    )
  );

  return _react2.default.createElement(
    _TwoWayTransition2.default,
    {
      onCloseComplete: onCloseComplete,
      onCloseStart: function onCloseStart() {
        setOpenComplete(false);
        if (_onCloseStart) _onCloseStart();
      },
      onOpenComplete: function onOpenComplete() {
        setOpenComplete(true);
        if (_onOpenComplete) _onOpenComplete();
      },
      onOpenStart: onOpenStart,
      transitionOnMount: animateOnMount,
      duration: animateOnToggle ? transitionDuration : 0,
      Wrapper: PopoverTransitionWrapper
    },
    renderedPopover
  );
});

UIPopoverContent.propTypes = {
  animateOnMount: _propTypes2.default.bool.isRequired,
  animateOnToggle: _propTypes2.default.bool,
  arrowColor: _propTypes2.default.string,
  arrowSize: _propTypes2.default.oneOf(Object.keys(_UIPopoverArrow2.default.ARROW_SIZES)).isRequired,

  content: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
    header: _propTypes2.default.node,
    body: _propTypes2.default.node,
    footer: _propTypes2.default.node
  })]),
  Content: _propTypes2.default.elementType,
  onCloseComplete: _propTypes2.default.func,
  onCloseStart: _propTypes2.default.func,
  onOpenChange: _propTypes2.default.func,
  onOpenComplete: _propTypes2.default.func,
  onOpenStart: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  placement: _propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
  showCloseButton: _propTypes2.default.bool,
  use: _propTypes2.default.oneOf(Object.keys(_Use.USE_CLASSES)),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

UIPopoverContent.defaultProps = {
  animateOnMount: false,
  open: false,
  placement: 'top',
  use: 'default'
};

UIPopoverContent.displayName = 'UIPopoverContent';

exports.default = UIPopoverContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/tooltip/UIPopoverContent.js
// module id = 469
// module chunks = 177